import { Documento, ProcessoRiferimento,  LegalEntityEprocessiRiferimentoResult } from '../../models/data.model';
import { Component, OnInit, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../../services/data.service';
import { CommonService } from '../../services/common.service';
import { EqualtecService } from '../../services/equaltec.service';

@Component({
  selector: 'app-equaltec-home',
  templateUrl: './EqualtecHome.component.html'
})

export class EqualtecHome implements OnInit {
  @ViewChild('Or') OrElement;
  @ViewChild('And') AndElement;

  constructor(public translate: TranslateService,
    private dataService: DataService,
    private documentservice: CommonService<Documento>,
    private processoRiferimentoService: CommonService<LegalEntityEprocessiRiferimentoResult>,
    private equaltecService: EqualtecService
  ) { }


  isScrittaLaterale: boolean = true;
  isFilter: boolean = false;
  isExpandedSearch: boolean = false;
  isDetailSearch = false;
  isTabellaSearchRevisionPending: boolean = false;
  checkBoxValue: string = 'and';
  searchCodice: string;
  searchOggetto: string;
  searchFullText: string;



  labelNoRecord: boolean = false;
  isLegalentityTitleInterno: boolean = false;
  docApertiSearch: number = 0;

  ngOnInit(): void {
    //this.caricaLegalEntityEProcessidiRiferimento();
    // Questo è veramente un casino:
    // quanto viene caricato service-ita.component tramite il routing personale del modulo, si inserisce nel dataService il nome del titolo del componente
    // a questo ComponentInput si sottoscrive il padre di di service-ita, cioè custom-layout.component, che renderizza il titolo in alto
    this.dataService.ComponentInput = '';
  }

  
  isFilterFunc(): void {
    this.isFilter = !this.isFilter;
  }

 

  onCheckBoxChange(CheckBoxValue: string): void {
    if (CheckBoxValue != null && CheckBoxValue != undefined && CheckBoxValue != "") {
      if (CheckBoxValue == 'and') {
        this.OrElement.nativeElement.checked = false;
      }
      if (CheckBoxValue == 'or') {
        this.AndElement.nativeElement.checked = false;
      }
      this.checkBoxValue = CheckBoxValue;
    }
  }

  onResultClicked = () => {
    this.isDetailSearch = true;
    let customtag = "";
    if (this.searchCodice) {
      customtag += "Codice," + this.searchCodice;
    }
    if (this.searchOggetto) {
      customtag += this.searchCodice != '' ? "#" : "";
      customtag += "Descrizione," + this.searchOggetto;
    }
    return this.showResult(customtag, this.searchFullText, this.searchOggetto);
  }

  showResult = (customtag: string, textTosearch: string, nomeAllegato: string) => {
    this.labelNoRecord = false;
    this.isTabellaSearchRevisionPending = false;
    this.isExpandedSearch = false;
    const url = 'api/rest/LoadFilteredEqualtecequaltecService.documents';
    if (this.checkBoxValue == null) {
      this.checkBoxValue = 'and';
    }
    console.log(this.equaltecService.selectedLegalEntity)
    const input = { customtag: customtag, fulltextquery: textTosearch, conjunction: this.checkBoxValue, filtrolegalEntity: this.equaltecService.selectedLegalEntity };
    this.documentservice.postData(url, input, false).subscribe(result => {
      if (result) {
        this.isLegalentityTitleInterno = true;

        this.docApertiSearch = 0;
        console.log('this is equaltecService.documents : ', result);
        this.equaltecService.documents = result as Documento[];
        this.equaltecService.documents.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = "Open detail";
          if (d.isNewRevisionPending) {
            this.isTabellaSearchRevisionPending = true;
          }
        });
      }
      this.labelNoRecord = true;
    })
  }

  
 }
